const ERISIM_ANAHTAR = 'emanetx.erisimJeton';
const YENILEME_ANAHTAR = 'emanetx.yenilemeJeton';
/**
 * Tarayicidaki localStorage'a yazan basit jeton depo.
 * Test/SSR ortamlarinda window yoksa belege-bos donus.
 */
export function tarayiciJetonDepo() {
    const var_ = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
    return {
        erisim: () => (var_ ? window.localStorage.getItem(ERISIM_ANAHTAR) : null),
        yenileme: () => (var_ ? window.localStorage.getItem(YENILEME_ANAHTAR) : null),
        yaz: ({ erisimJeton, yenilemeJeton }) => {
            if (!var_)
                return;
            window.localStorage.setItem(ERISIM_ANAHTAR, erisimJeton);
            window.localStorage.setItem(YENILEME_ANAHTAR, yenilemeJeton);
        },
        sil: () => {
            if (!var_)
                return;
            window.localStorage.removeItem(ERISIM_ANAHTAR);
            window.localStorage.removeItem(YENILEME_ANAHTAR);
        },
    };
}
/**
 * Bellek tabanli depo (testler veya Node CLI icin).
 */
export function bellekJetonDepo() {
    let erisim = null;
    let yenileme = null;
    return {
        erisim: () => erisim,
        yenileme: () => yenileme,
        yaz: (c) => {
            erisim = c.erisimJeton;
            yenileme = c.yenilemeJeton;
        },
        sil: () => {
            erisim = null;
            yenileme = null;
        },
    };
}
//# sourceMappingURL=jeton-depo.js.map